export const sections = {
    home: [
        {
            id: "content-frontpage-breaking-news",
            name: "ニュース速報",
        },
        {
            id: "content-frontpage-latest-news",
            name: "最新ニュース",
        },
        {
            id: "content-frontpage-latest-media",
            name: "最新のメディア",
        },
        {
            id: "content-frontpage-highlights",
            name: "ハイライト",
        },
        {
            id: "content-frontpage-top-stories",
            name: "トップストーリー",
        },
        {
            id: "content-frontpage-international",
            name: "国際的",
        },
        {
            id: "content-frontpage-featured",
            name: "特徴",
        },
        {
            id: "content-frontpage-underscored",
            name: "強調されています",
        },
        {
            id: "content-frontpage-happening-now",
            name: "今起こってる",
        },
        {
            id: "content-frontpage-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-frontpage-paid-content",
            name: "有料コンテンツ",
        },
    ],
    us: [
        {
            id: "content-us-world-news",
            name: "世界のニュース",
        },
        {
            id: "content-us-around-the-nation",
            name: "全国の周り",
        },
        {
            id: "content-us-roundup",
            name: "切り上げする",
        },
        {
            id: "content-us-crime+justice",
            name: "犯罪と正義",
        },
        {
            id: "content-us-around-the-us",
            name: "米国周辺",
        },
        {
            id: "content-us-latest-media",
            name: "最新のメディア",
        },
        {
            id: "content-us-business",
            name: "仕事",
        },
        {
            id: "content-us-underscored",
            name: "強調されています",
        },
        {
            id: "content-us-state-by-state",
            name: "州ごと",
        },
        {
            id: "content-us-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-us-paid-content",
            name: "有料コンテンツ",
        },
    ],
    world: [
        {
            id: "content-world-global-trends",
            name: "グローバルな傾向",
        },
        {
            id: "content-world-around-the-world",
            name: "世界中で",
        },
        {
            id: "content-world-latest-media",
            name: "最新のメディア",
        },
        {
            id: "content-world-today",
            name: "今日",
        },
        {
            id: "content-world-featured",
            name: "特徴",
        },
        {
            id: "content-world-international",
            name: "国際的",
        },
        {
            id: "content-world-global-impact",
            name: "グローバルな影響",
        },
        {
            id: "content-world-underscored",
            name: "強調されています",
        },
        {
            id: "content-world-global-issues",
            name: "地球規模の問題",
        },
        {
            id: "content-world-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-world-paid-content",
            name: "有料コンテンツ",
        },
    ],
    politics: [
        {
            id: "content-politics-what-really-matters",
            name: "本当に重要なこと",
        },
        {
            id: "content-politics-today",
            name: "今日",
        },
        {
            id: "content-politics-latest-headlines",
            name: "最新のヘッドライン",
        },
        {
            id: "content-politics-latest-media",
            name: "最新のメディア",
        },
        {
            id: "content-politics-election",
            name: "選挙",
        },
        {
            id: "content-politics-more-political-news",
            name: "より政治的なニュース",
        },
        {
            id: "content-politics-underscored",
            name: "強調されています",
        },
        {
            id: "content-politics-trending",
            name: "トレンド",
        },
        {
            id: "content-politics-around-the-world",
            name: "世界中で",
        },
        {
            id: "content-politics-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-politics-paid-content",
            name: "有料コンテンツ",
        },
    ],
    business: [
        {
            id: "content-business-latest-trends",
            name: "最新のトレンド",
        },
        {
            id: "content-business-market-watch",
            name: "マーケットウォッチ",
        },
        {
            id: "content-business-economy-today",
            name: "今日の経済",
        },
        {
            id: "content-business-must-read",
            name: "必読",
        },
        {
            id: "content-business-educational",
            name: "教育",
        },
        {
            id: "content-business-underscored",
            name: "強調されています",
        },
        {
            id: "content-business-investing-101",
            name: "投資101",
        },
        {
            id: "content-business-stock-market",
            name: "株式市場",
        },
        {
            id: "content-business-impact",
            name: "影響",
        },
        {
            id: "content-business-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-business-paid-content",
            name: "有料コンテンツ",
        },
    ],
    opinion: [
        {
            id: "content-opinion-a-deeper-look",
            name: "より深い外観",
        },
        {
            id: "content-opinion-top-issues",
            name: "トップの問題",
        },
        {
            id: "content-opinon-trending",
            name: "トレンド",
        },
        {
            id: "content-opinion-think-about-it",
            name: "それについて考えてください",
        },
        {
            id: "content-opinion-latest-media",
            name: "最新のメディア",
        },
        {
            id: "content-opinion-in-case-you-missed-it",
            name: "あなたがそれを逃した場合に備えて",
        },
        {
            id: "content-opinion-environmental-issues",
            name: "環境問題",
        },
        {
            id: "content-opinion-underscored",
            name: "強調されています",
        },
        {
            id: "content-opinon-what-matters-most",
            name: "最も重要なこと",
        },
        {
            id: "content-opinion-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-opinion-paid-content",
            name: "有料コンテンツ",
        },
    ],
    health: [
        {
            id: "content-health-trending",
            name: "トレンド",
        },
        {
            id: "content-health-latest-facts",
            name: "最新の事実",
        },
        {
            id: "content-health-medical-breakthroughs",
            name: "医療ブレークスルー",
        },
        {
            id: "content-health-latest-videos",
            name: "最新のビデオ",
        },
        {
            id: "content-health-educational",
            name: "教育",
        },
        {
            id: "content-health-fitness",
            name: "フィットネス",
        },
        {
            id: "content-health-guides",
            name: "ガイド",
        },
        {
            id: "content-health-underscored",
            name: "強調されています",
        },
        {
            id: "content-health-what-to-eat",
            name: "何を食べれば良いか",
        },
        {
            id: "content-health-hot-topics",
            name: "ホットな話題",
        },
        {
            id: "content-health-paid-content",
            name: "有料コンテンツ",
        },
    ],
};
